/**
 * `/account/security` became the Settings page. Redirect old links, bookmarks
 * and in-flight Google link callbacks there, keeping the query (`?google=…`)
 * and the tab hash (`#devices`, `#agents`).
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_shell/account/security')({
  beforeLoad: ({ location }) => {
    const { search, hash } = location as { search: Record<string, string>; hash: string }
    throw redirect({ to: '/account/settings', search, hash: hash || undefined, replace: true })
  },
})
